/**
 * Capitalize only first word in all string
 */
function capitalizeLine(s: string) {
  return s[0].toUpperCase() + s.slice(1);
}

export default capitalizeLine;
